<div class="outer-wrapper">
  <dx-load-panel [showIndicator]="true" [showPane]="false" [shading]="false" [(visible)]="bIsLoading"
    [closeOnOutsideClick]="false"></dx-load-panel>

  <dx-box *ngIf="isDiagnosisLayoutSelected()" direction="col" width="100%" height="100%">
    <dxi-item [ratio]="1">
      <div class="div-scroll-view" >
        <form [formGroup]="form">
          <div *ngFor="let diagnosisItem of diagnosisItems" class="form-row">
            <app-form-item [formItem]="diagnosisItem" [form]="diagnosisForm"></app-form-item>
          </div>
        </form>
      </div>
      <!-- <div *ngIf="bShowStatusMessage" class="diag-status-bar-wrapper">
        <label class="diag-status-bar">{{diagnosisStatusMessage}}</label>
      </div> -->
    </dxi-item>
  </dx-box>

  <dx-box *ngIf="isWorksheetLayoutSelected()" direction="col" width="100%" height="100%">
    <dxi-item [ratio]="1">
      <dx-box direction="col" width="100%" height="100%">
        <dxi-item [ratio]="5">
          <div class="div-scroll-view"
            id="WorksheetLayoutScrollView">
            <form (ngSubmit)="onSubmit()" [formGroup]="form">
              <div *ngFor="let formItem of formItems" class="form-row">
                <app-form-item [formItem]="formItem" [form]="form"></app-form-item>
              </div>

            </form>
          </div>
        </dxi-item>

        <dxi-item [ratio]="1" [visible]="bShowStatusMessage">
          <div class="div-scroll-view">
            <form [formGroup]="form">
              <div class="error-list-title">Errors and Warnings</div>
              <div *ngFor="let errorItem of errorList">
                <div class="error-list-entry-wrapper">
                  <button class="error-list-entry-link" *ngIf="errorItem.IsLinkedToControl == true"
                    (click)="onErrorLinkClicked($event, errorItem)">{{errorItem.LinkText}}</button>
                  <div class="warning-list-entry-link" *ngIf="errorItem.IsLinkedToControl == false">{{errorItem.LinkText}}</div>
                  <div class="error-list-entry-message">{{errorItem.Message}}</div>
                </div>
              </div>
            </form>
          </div>
        </dxi-item>
      </dx-box>

      <!-- <div *ngIf="bShowStatusMessage" class="diag-status-bar-wrapper">
        <label class="diag-status-bar">{{diagnosisStatusMessage}}</label>
      </div> -->
    </dxi-item>
  </dx-box>

  <dx-box *ngIf="is2PanelHorizontalLayoutSelected()" direction="row" width="100%" height="100%">
    <dxi-item [ratio]="1">
      <dx-box direction="col" width="100%" height="100%">
        <dxi-item [ratio]="5">
          <div class="div-scroll-view"
               id="TwoPanelHorizScrollView">
            <form (ngSubmit)="onSubmit()" [formGroup]="form">
              <div *ngFor="let formItem of formItems" class="form-row">
                <app-form-item [formItem]="formItem" [form]="form"></app-form-item>
              </div>

            </form>
          </div>
        </dxi-item>

        <dxi-item [ratio]="1" [visible]="bShowStatusMessage">
          <div class="div-scroll-view">
            <form [formGroup]="form">
              <div class="error-list-title">Errors and Warnings</div>
              <div *ngFor="let errorItem of errorList">
                <div class="error-list-entry-wrapper">
                  <button class="error-list-entry-link" *ngIf="errorItem.IsLinkedToControl == true"
                    (click)="onErrorLinkClicked($event, errorItem)">{{errorItem.LinkText}}</button>
                  <div class="warning-list-entry-link" *ngIf="errorItem.IsLinkedToControl == false">{{errorItem.LinkText}}</div>
                  <div class="error-list-entry-message">{{errorItem.Message}}</div>
                </div>
              </div>
            </form>
          </div>
        </dxi-item>
      </dx-box>

    </dxi-item>
    <dxi-item [ratio]="1">
      <div class="div-scroll-view" >
        <form [formGroup]="form">
          <div *ngFor="let diagnosisItem of diagnosisItems" class="form-row">
            <app-form-item [formItem]="diagnosisItem" [form]="diagnosisForm"></app-form-item>
          </div>
        </form>
      </div>
      <!-- <div *ngIf="bShowStatusMessage" class="diag-status-bar-wrapper">
        <label class="diag-status-bar">{{diagnosisStatusMessage}}</label>
      </div> -->
    </dxi-item>
  </dx-box>

  <dx-box *ngIf="is2PanelVerticalLayoutSelected()" direction="col" width="100%" height="100%">
    <dxi-item [ratio]="2">
      <dx-box direction="col" width="100%" height="100%">
        <dxi-item [ratio]="5">
          <dx-box direction="col" width="100%" height="100%">
            <dxi-item [ratio]="5">
              <div class="div-scroll-view" id="TwoPanelVertScrollView">
                <form (ngSubmit)="onSubmit()" [formGroup]="form">
                  <div *ngFor="let formItem of formItems" class="form-row">
                    <app-form-item [formItem]="formItem" [form]="form"></app-form-item>
                  </div>
    
                </form>
              </div>
            </dxi-item>
    
            <dxi-item [ratio]="1" [visible]="bShowStatusMessage">
              <div class="div-scroll-view">
                <form [formGroup]="form">
                  <div class="error-list-title">Errors and Warnings</div>
                  <div *ngFor="let errorItem of errorList">
                    <div class="error-list-entry-wrapper">
                      <button class="error-list-entry-link" *ngIf="errorItem.IsLinkedToControl == true"
                        (click)="onErrorLinkClicked($event, errorItem)">{{errorItem.LinkText}}</button>
                      <div class="warning-list-entry-link" *ngIf="errorItem.IsLinkedToControl == false">{{errorItem.LinkText}}</div>
                      <div class="error-list-entry-message">{{errorItem.Message}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </dxi-item>
          </dx-box>
    
        </dxi-item>
      </dx-box>
    </dxi-item>
    <dxi-item [ratio]="1">
      <div class="div-scroll-view">
        <form [formGroup]="form">
          <div *ngFor="let diagnosisItem of diagnosisItems" class="form-row">
            <app-form-item [formItem]="diagnosisItem" [form]="diagnosisForm"></app-form-item>
          </div>
        </form>
      </div>
      <!-- <div *ngIf="bShowStatusMessage" class="diag-status-bar-wrapper">
        <label class="diag-status-bar">{{diagnosisStatusMessage}}</label>
      </div> -->
    </dxi-item>
  </dx-box>


 
</div>